import React from "react";
import PropTypes from "prop-types";
import {
  RadioCardInput,
  RadioCardLabel,
  RadioCardsFieldset,
  RadioCardWrapper,
  RadioCardDescription,
  RadioCardImage,
  RadioCardTitle,
} from "./styled";

const RadioCard = ({
  option,
  name,
  checked = false,
  onChange,
  onBlur,
  disabled = false,
  required = false,
  ariaInvalid = false,
}) => {
  const id = `${name}-${option.value}`;
  return (
    <RadioCardWrapper>
      <RadioCardInput
        id={id}
        name={name}
        type="radio"
        value={option.value}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        required={required}
        aria-invalid={ariaInvalid}
      />
      <RadioCardLabel htmlFor={id}>
        {option.icon ? <RadioCardImage>{option.icon}</RadioCardImage> : null}
        <RadioCardTitle weight={700}>{option.label}</RadioCardTitle>
        <RadioCardDescription weight={400}>
          {option.description}
        </RadioCardDescription>
      </RadioCardLabel>
    </RadioCardWrapper>
  );
};
RadioCard.propTypes = {
  option: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  ariaInvalid: PropTypes.bool,
};

export const RadioCards = ({
  name,
  value,
  onChange,
  onBlur,
  className,
  disabled,
  options,
  ariaInvalid,
}) => {
  return (
    <RadioCardsFieldset className={className} aria-invalid={ariaInvalid}>
      {options.map((option) => (
        <RadioCard
          key={option.value}
          name={name}
          option={option}
          checked={value === option.value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          required={option.required}
        />
      ))}
    </RadioCardsFieldset>
  );
};

RadioCards.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
      disabled: PropTypes.bool,
      value: PropTypes.string.isRequired,
      icon: PropTypes.element,
    })
  ).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  ariaInvalid: PropTypes.bool,
};
